import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "./WhatsAppButton.css";

// 1) PUT YOUR NUMBER HERE (digits only, include country code)
const WHATSAPP_NUMBER = "919209679072";

// 2) CHANGE THIS DEFAULT MESSAGE IF YOU WANT
const DEFAULT_MESSAGE = "Hi TravXplo! I’d like help planning a trip.";

export default function WhatsAppButton({
  place = "beside", // "beside" (left of chatbot) or "above"
}) {
  const link = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    DEFAULT_MESSAGE
  )}`;

  // CSS class for position
  const positionClass =
    place === "above" ? "wa-above-chatbot" : "wa-beside-chatbot";

  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className={`wa-fab ${positionClass}`}
      aria-label="Chat with us on WhatsApp"
      title="Chat with us on WhatsApp"
    >
      <FaWhatsapp className="wa-icon" />
    </a>
  );
}
